<template>
  <v-checkbox
    :density="dense ? 'compact' : 'default'"
    hide-details
    :disabled="isRequired || disabled"
    :class="{
      'my-0': dense,
      'my-4': !dense,
    }"
    v-model="selectedPermissions"
    :value="permission.id"
    multiple
    :label="label"
    @update:model-value="emit('update:modelValue', selectedPermissions)"
  />
</template>

<script setup>
import { ref, computed, watch } from "vue";

const props = defineProps({
  permission: {
    type: Object,
    required: true,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  dense: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  modelValue: {
    type: [Array, Object],
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const selectedPermissions = ref([...props.modelValue]);

const label = computed(() => props.permission.action_description);

watch(
  () => props.modelValue,
  (newVal) => {
    selectedPermissions.value = [...newVal];
  },
  { immediate: true },
);
</script>
